<!-- 养护添加 -->
<template>
   <div>
      <div class="demo-drawer__content data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
               <template slot="tabs" slot-scope="scope">
                  <div class="table_content_box">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0">
                        <el-form label-width="100px" id="mainInfo" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini" :disabled="dataActionBox.actionType == 2">
                           <el-row v-if="dataActionBox.actionType != 2">
                              <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                 <el-select v-if="formOneValue.entityField == 'scmType'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择" @change="handlescmTypeChange"
                                            :disabled="formOneValue.isChange == 0">
                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                    </el-option>
                                 </el-select>
                                 <!-- 检索方案 -->
                                 <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]"
                                           @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)">
                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                 </el-input>

                                 <el-date-picker v-else-if="formOneValue.entityField == 'curingDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                 value-format="timestamp">
                                 </el-date-picker>
                                 <el-input v-else v-model="sendDataInfo[formOneValue.entityField]" :disabled="false">
                                 </el-input>
                              </el-form-item>
                           </el-row>
                           <el-row v-if="dataActionBox.actionType == 2">
                              <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span v-if="formOneValue.fieldType == 'date'">
                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                 </span>
                                 <span v-else-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                    sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'formatter'">
                                    <span v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" v-if="item.key == sendDataInfo[formOneValue.entityField]">{{
                                                        item.value }}</span>
                                 </span>
                                 <span v-else> {{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>
                        <el-form :inline="true" size="mini">
                           <div style="margin-bottom: .2rem;">
                              <el-button type="primary" size="mini" @click="showBatchSetDialog" v-if="dataActionBox.actionType != 2">
                                 批量设置
                              </el-button>
                           </div>
                           <u-table id="mxTable" :data="sendDataInfo.detailList" border style="width: 100%" :height="mxHeight" size="mini"
                              :row-height="35" row-key="index" use-virtual>
                              <u-table-column align="center" v-if="formOneValue.isShow == 1" min-width="180" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm"
                                               :key="formOneKey">
                                 <template slot-scope="scope">
                                    <div v-if="dataActionBox.actionType != 2">
                                       <!-- 系统字段 -->
                                       <el-input v-if="formOneValue.entityField == 'curNum'" :min="0" type="number" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'reason'" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-date-picker v-else-if="formOneValue.entityField == 'cpdCdate'" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" type="date" placeholder="选择日期"
                                                       format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                       </el-date-picker>
                                       <el-input v-else-if="formOneValue.entityField == 'cpdCperson'" @focus="openSearch(formOneValue.searchId, scope.$index, 'cpdCperson')"
                                                 v-model="sendDataInfo.detailList[scope.$index].opmName">
                                       </el-input>
                                       <el-select v-else-if="formOneValue.entityField == 'measures'" multiple collapse-tags v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="item in dictionariesData" :key="item.diValue" :label="item.diValue" :value="item.diValue"></el-option>
                                       </el-select>
                                       <div v-else-if="formOneValue.fieldType == 'formatter'">
                                          <el-select v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                          </el-select>
                                       </div>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                       </span>
                                       <el-input v-else-if="formOneValue.entityField == 'conclusion'" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'remark'" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span> {{
                                                            $common.getLocalTime(scope.row[formOneValue.entityField])
                                                        }}</span>
                                       </span>
                                       <span v-else>
                                          {{
                                                            sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                        }}</span>
                                    </div>
                                    <div v-else>
                                       <span v-if="formOneValue.fieldType == 'date'">
                                          {{ $common.getLocalTime(
                                                            sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                                        }}
                                       </span>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                       </span>

                                       <span v-else-if="formOneValue.entityField == 'measures'">
                                          <el-tag v-for="(measure, index) in getMeasuresArray(sendDataInfo.detailList[scope.$index][formOneValue.entityField])" :key="index" size="mini" style="margin-right: 5px;">
                                             {{ measure }}
                                          </el-tag>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'formatter'">
                                          <span v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" v-if="item.key == sendDataInfo.detailList[scope.$index][formOneValue.entityField]">{{
                                                                item.value }}</span>
                                       </span>
                                       <span v-else> {{
                                                        sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                        }}</span>
                                    </div>

                                 </template>
                              </u-table-column>

                           </u-table>
                        </el-form>
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
         <!-- 页脚 -->
         <div class="foot">
            <div style="text-align: center;">
               <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
               <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
            <div style="text-align: center;" v-if="formDataList[2]">
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>

      <!-- 批量设置弹窗 -->
      <el-dialog title="批量设置" append-to-body :visible.sync="batchSetDialogVisible" width="800px" center :close-on-click-modal="false">
         <el-form :inline="true" :model="batchSetForm" ref="batchSetForm" label-width="120px" size="small">
            <!-- <el-form-item label="陈列数量:">
               <el-input :min="0" type="number" placeholder="请输入陈列数量" v-model="batchSetForm.curNum"></el-input>
            </el-form-item> -->

            <el-form-item label="陈列原因:">
               <el-input v-model="batchSetForm.reason" placeholder="请输入陈列原因" type="textarea" :rows="2">
               </el-input>
            </el-form-item>

            <el-form-item label="陈列措施:">
               <el-select v-model="batchSetForm.measures" multiple collapse-tags placeholder="请选择陈列措施" style="width: 100%">
                  <el-option v-for="item in dictionariesData" :key="item.diValue" :label="item.diValue" :value="item.diValue">
                  </el-option>
               </el-select>
            </el-form-item>

            <el-form-item label="陈列结论:">
               <el-input v-model="batchSetForm.conclusion" placeholder="请输入陈列结论" type="textarea" :rows="2">
               </el-input>
            </el-form-item>

            <el-form-item label="备注:">
               <el-input v-model="batchSetForm.remark" placeholder="请输入备注" type="textarea" :rows="2">
               </el-input>
            </el-form-item>
         </el-form>

         <div slot="footer" class="dialog-footer">
            <el-button @click="batchSetDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="applyBatchSet">确定</el-button>
         </div>
      </el-dialog>

      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
   name: "ypcxListAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            cpmId: "",
            lomAppreason: "",
            lomApptype: 0,
            lomReserves1: "",
            lomReserves2: "",
            lomReserves3: "",
            lomReserves4: "",
            lomReserves5: "",
            lomReserves6: "",
            lomId: "",
            ids: [],
            curingDate: '',
            scmType: '',
            detailList: [],
            totalMoney: 0,
            totalNumber: 0,
            totalCount: 0,
            stName: '',
            stId: ''
         },
         detaislDataInfo: {},
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         tabForm: [],
         mxForm: [],
         footForm: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         mxHeight: 400,
         parentSearchData: {},
         sField: '',
         seType: '',
         dictionariesData: [],
         // 批量设置相关
         batchSetDialogVisible: false,
         batchSetForm: {
            curNum: null,
            reason: '',
            measures: [],
            conclusion: '',
            remark: ''
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'sendDataInfo.detailList': {
         handler(newVal) {
            newVal.forEach(item => {
               if (this.dataActionBox.actionType != 2) {
                  if (item.curNum > item.num) {
                     this.$message.error('陈列数量不能大于库存数量');
                     item.curNum = item.num;
                  }
               }
            });
         },
         deep: true,
         immediate: true
      }
   },
   //方法集合
   methods: {
      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [19],
         });
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result.yhcs;
            console.log(this.dictionariesData);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 处理 measures 数据格式转换
      getMeasuresArray(measures) {
         if (!measures) return [];
         if (Array.isArray(measures)) return measures;
         if (typeof measures === 'string') {
            return measures.split(',').filter(item => item.trim());
         }
         return [];
      },
      // 确保 measures 字段格式正确
      formatMeasuresData() {
         if (this.sendDataInfo.detailList && this.sendDataInfo.detailList.length > 0) {
            this.sendDataInfo.detailList.forEach((item, index) => {
               if (item.measures) {
                  // 如果是字符串，转换为数组
                  if (typeof item.measures === 'string') {
                     this.$set(this.sendDataInfo.detailList[index], 'measures',
                        item.measures.split(',').filter(m => m.trim()));
                  }
               } else {
                  // 如果没有 measures 字段，初始化为空数组
                  this.$set(this.sendDataInfo.detailList[index], 'measures', []);
               }
            });
         }
      },

      // 显示批量设置弹窗
      showBatchSetDialog() {
         if (!this.sendDataInfo.detailList || this.sendDataInfo.detailList.length === 0) {
            this.$message.warning('暂无明细数据可设置');
            return;
         }

         // 重置表单数据
         this.batchSetForm = {
            curNum: null,
            reason: '',
            measures: [],
            conclusion: '',
            remark: ''
         };

         this.batchSetDialogVisible = true;
      },

      // 应用批量设置
      applyBatchSet() {
         if (!this.sendDataInfo.detailList || this.sendDataInfo.detailList.length === 0) {
            this.$message.warning('暂无明细数据可设置');
            return;
         }

         // 检查是否至少填写了一个字段
         const hasValue = this.batchSetForm.curNum !== null ||
            this.batchSetForm.reason.trim() !== '' ||
            this.batchSetForm.measures.length > 0 ||
            this.batchSetForm.conclusion.trim() !== '' ||
            this.batchSetForm.remark.trim() !== '';

         if (!hasValue) {
            this.$message.warning('请至少填写一个字段');
            return;
         }

         // 应用到所有明细行
         this.sendDataInfo.detailList.forEach((item, index) => {
            // 只设置有值的字段

            if (this.batchSetForm.reason.trim() !== '') {
               this.$set(this.sendDataInfo.detailList[index], 'reason', this.batchSetForm.reason);
            }
            if (this.batchSetForm.measures.length > 0) {
               this.$set(this.sendDataInfo.detailList[index], 'measures', [...this.batchSetForm.measures]);
            }
            if (this.batchSetForm.conclusion.trim() !== '') {
               this.$set(this.sendDataInfo.detailList[index], 'conclusion', this.batchSetForm.conclusion);
            }
            if (this.batchSetForm.remark.trim() !== '') {
               this.$set(this.sendDataInfo.detailList[index], 'remark', this.batchSetForm.remark);
            }
         });

         this.batchSetDialogVisible = false;
         this.$message.success('批量设置成功');
      },

      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      // 打印方法
      showPrintPlan() {
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.focusIndex = index;
         this.sField = sField
         this.DialogVisible = true;
         this.seType = type
         this.seId = sId;
         if (type == 'bgmName') {
            if (this.sendDataInfo.detailList[index][type]) { this.parentSearchData[type] = this.sendDataInfo.detailList[index][type] }
            else { this.parentSearchData[type] = '' }
            return
         }
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            //赋值给当前行
            if (this.seType == 'bgmName') {
               for (const key in val) {
                  if (Object.hasOwnProperty.call(val, key)) {
                     this.$set(
                        this.sendDataInfo.detailList[this.focusIndex],
                        key,
                        val[key]
                     );
                  }
               }
            } else {
               this.paramValue(val)
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         console.log(this.sField)
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      async handlescmTypeChange(value) {
         console.log(value, 'handlescmTypeChange');
         try {
            let res = await this.$http.storeShelfGetUnCuringList({ type: value });
            if (res.status == 200 && res.result) {
               // 使用 $nextTick 和 Vue.set 避免页面白屏
               this.$nextTick(() => {

                  this.sendDataInfo.detailList = res.result;
                  this.sendDataInfo.detailList.forEach(item => {
                     this.$set(item, 'curNum', item.num);
                  });

               });
            } else {
               this.$message({
                  message: res.message,
                  type: 'error'
               });
            }
         } catch (error) {
            console.error('获取数据失败:', error);
            this.$message({
               message: '获取数据失败，请重试',
               type: 'error'
            });
         }
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               return false;
            }
         });
         if (flag) return false;
         let ids = [];
         this.sendDataInfo.detailList.forEach((item) => {
            ids.push(item.bgsId);
         });
         this.sendDataInfo.ids = ids;
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.detailList.forEach((item, index) => {
            let a = item.measures.join();
            sendData.detailList[index].measures = a;
         });
         var responseData = await this.$http.storeShelfAddCuring(sendData);

         if (responseData.status == 200) {
            this.$emit("drawerCancel");
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel");
            })
            .catch(() => { });
      },

      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },
      //新增明细
      addDetails(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
               this.sendDataInfo.detailList.push(JSON.parse(JSON.stringify(this.detaislDataInfo)));
            } else {
               return this.$message({
                  message: "请先完善主信息",
                  type: "error",
               });
            }
         });
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.detailList.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.$confirm('确定删除该明细?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
            this.selectedDetailsIndex = 0;
            this.$message({
               type: 'success',
               message: '删除成功!'
            });
         }).catch(() => {
         });

      },
      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量

         this.sendDataInfo.lomApptype = 0;
         this.sendDataInfo.detailList = [];
      },
      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         // oldData = JSON.parse(JSON.stringify(oldData)); //防干扰
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            this.sendDataInfo.detailList = [];
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            for (const key in this.sendDataInfo) {
               if (key == "detailList") {
                  this.sendDataInfo.detailList = [];
                  dataInfo.detailList.forEach(async (item, keys) => {
                     this.sendDataInfo.detailList.push(item);
                  });
                  // 格式化 measures 数据
                  this.$nextTick(() => {
                     this.formatMeasuresData();
                  });
               }
            }
         } else if (this.dataActionBox.actionType == 2) {
            this.dataActionBox.boxTitle = "查看信息";
            this.sendDataInfo.detailList = [];
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            for (let key in this.sendDataInfo) {
               if (key == "detailList") {
                  this.sendDataInfo.detailList = [];
                  dataInfo.detailList.forEach(async (item, keys) => {
                     this.sendDataInfo.detailList.push(item);
                  });
                  // 格式化 measures 数据
                  this.$nextTick(() => {
                     this.formatMeasuresData();
                  });
               }
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "detailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "lomApptype", 0)
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPartDictionariesData();
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}

::v-deep .el-form-item__content {
   width: 200px;
}
</style>